import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  /*async getControlPoints(store) {
    const { commit, rootState, rootGetters } = store;
    const { page, per_page } = rootState.misc.pagination;
    return await axios({
      url: `/v1/projects/list?include=fnd,responsible,attachments&page=${page}&per_page=${per_page}&${rootGetters['misc/navigationString']}`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setProjects', resp.data.data);
        commit('misc/setTotalPages', resp.data.meta.pagination.total_pages, { root: true });
        return Promise.resolve(resp.data.data);
      })
      .catch(resp => {
        const error = resp && resp.data && resp.data.error
        if (error) {
          return Promise.reject(resp.data.error)
        }
        return Promise.reject(resp)
      });
  },*/
  async getControlPointByID(store, controlPointID) {
    const { commit } = store;
    return await axios({
      url: `/v1/control-points/${controlPointID}?include=organization,fnd,fnd.employees,executor,responsible,attachments,attachments.author,attachments.files,affected,dependent,project.event`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setControlPoint', resp.data.data);
        commit('events/setEvent', resp.data.data.project.event, {root: true});
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async getProjectControlPoints(store) {
    const { commit, state, rootState, rootGetters } = store;
    const { page, per_page } = rootState.misc.pagination;
    return await axios({
      url: `/v1/projects/${state.project.id}/control-points/list?include=organization,fnd,executor,responsible,attachments,affected,dependent&page=${page}&per_page=${per_page}&${rootGetters['misc/navigationString']}`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setControlPoints', resp.data.data);
        commit('misc/setTotalPages', resp.data.meta.pagination.total_pages, { root: true });
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async createControlPoint(store, controlPoint) {
    const { dispatch, state, rootState } = store;
    return await axios({
      url: `/v1/control-points`,
      method: 'POST',
      data: {
        ...controlPoint,
        event_id: rootState.events.event.id,
        project_id: state.project.id
      },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getProjectControlPoints');
        return Promise.resolve(resp);
      })
      .catch(parseApiError);
  },
  async updateControlPoint(store, controlPoint) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/control-points/${controlPoint.id}`,
      method: 'PUT',
      data: { ...controlPoint },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getControlPointByID', controlPoint.id);
        if (state.project.id !== 0) dispatch('getProjectControlPoints');
        dispatch('dashboard/updateContext', null, { root:true });
        return Promise.resolve(resp);
      })
      .catch(parseApiError);
  },
  async deleteControlPoint(store, controlPointID) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/control-points/${controlPointID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        if (state.project.id !== 0) dispatch('getProjectControlPoints');
        dispatch('dashboard/updateContext', null, { root:true });
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async addInfluenceToControlPoint(store, data) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/control-points/${data.controlPointID}/add-influence`,
      method: 'POST',
      data: { control_point_id: data.relation },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getControlPointByID', data.controlPointID);
        if (state.project.id !== 0) dispatch('getProjectControlPoints');
        dispatch('dashboard/updateContext', null, { root:true });
        return Promise.resolve(resp);
      })
      .catch(parseApiError);
  },
  async deleteInfluenceFromControlPoint(store, data) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/control-points/${data.controlPointID}/remove-influence`,
      method: 'POST',
      data: { control_point_id: data.relation },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getControlPointByID', data.controlPointID);
        if (state.project.id !== 0) dispatch('getProjectControlPoints');
        dispatch('dashboard/updateContext', null, { root:true });
        return Promise.resolve(resp);
      })
      .catch(parseApiError);
  },
  async setControlPointStatus(store, data) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/control-points/${data.controlPointID}/status`,
      method: 'POST',
      data: { status: data.status },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getControlPointByID', data.controlPointID);
        if (state.project.id !== 0) dispatch('getProjectControlPoints');
        dispatch('dashboard/updateContext', null, { root:true });
        return Promise.resolve(resp);
      })
      .catch(parseApiError);
  },
  async delegateControlPoint(store, data) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/control-points/${data.controlPointID}/delegate`,
      method: 'POST',
      data: { user_id: data.user_id },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getControlPointByID', data.controlPointID);
        dispatch('dashboard/updateContext', null, { root:true });
        return Promise.resolve(resp);
      })
      .catch(parseApiError);
  },
};

export default actions;